import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { sanitizeRichtextHtml } from '../../sanitize/sanitizeRichtextHtml.js';
import { marginFields, weightField } from '../_shared/blockFields.js';
import { marginStyle, readWeight, richtextProseCss } from '../_shared/blockRender.js';
import { useProductState } from '../_shared/productContext.js';
/**
 * Shrine `product_description` — config-by-config. The block is intentionally minimal: its ONLY settings
 * are `margin_top` (def 21) + `margin_bottom` (def 21) under a Margins group. There are no colour, size,
 * alignment, or responsive settings in Shrine for this block — the description simply inherits the
 * theme's rich-text/body typography. The body is bound to `product.description` and renders nothing when
 * the product has no description (Shrine gates on `product.description != blank`).
 */
export const descriptionBlockSchema = {
    type: 'description',
    name: 'Description',
    max: 1,
    fields: [weightField, ...marginFields(21, 21)],
};
/**
 * Product description — the seller's description is rich HTML (the dashboard editor + Shopify `body_html`),
 * so it is rendered as sanitized HTML (the shared XSS allowlist: headings, lists, links, emphasis), NOT as
 * escaped text — otherwise the raw `<h2>…</h2>` tags would show literally. Renders nothing when the product
 * has no description, or when the sanitized HTML is empty (matches Shrine's blank guard).
 */
const DescriptionBlock = ({ block }) => {
    const ps = useProductState();
    if (!ps)
        return null;
    const html = sanitizeRichtextHtml(ps.product.description ?? '');
    if (!html)
        return null;
    const bs = block.settings;
    const weight = readWeight(bs);
    const cls = `aqx-desc-${block.id}`;
    return (_jsxs(_Fragment, { children: [_jsx("style", { dangerouslySetInnerHTML: { __html: richtextProseCss(cls) } }), _jsx("div", { className: cls, style: {
                    fontSize: 'var(--aqx-theme-text-base, 16px)',
                    lineHeight: 'var(--aqx-theme-lh-relaxed, 1.7)',
                    color: 'var(--aqx-scheme-text)',
                    fontWeight: weight || undefined,
                    ...marginStyle(bs, 21, 21),
                }, dangerouslySetInnerHTML: { __html: html } })] }));
};
export const descriptionBlock = {
    type: 'description',
    schema: descriptionBlockSchema,
    Component: DescriptionBlock,
    meta: { label: 'Description' },
};
//# sourceMappingURL=index.js.map